/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { StyledCoupon } from 'src/components/Coupons/CouponsContainer'

import { useThemeContext } from '../../../contexts/ThemeContext'
import { useWeb3Context } from '../../../contexts/Web3Context'
import { useCouponAmount } from '../../../hooks/useCouponAmount'
import FlexBox from '../../Common/FlexBox'
import Spinner from '../../Common/Spinner'
import CouponsComponent from '../../Coupons'

const Coupons = () => {
  const { active, account } = useWeb3Context()
  const { colors } = useThemeContext()

  const { couponAmount } = useCouponAmount({
    poll: true
  })

  if (!active || !account) {
    return null
  } else if (!couponAmount) {
    return (
      <StyledCoupon>
        <FlexBox as="span" alignItems="center" columnGap={3}>
          <Spinner size={16} stroke={colors.primary} />
          <span>Loading...</span>
        </FlexBox>
      </StyledCoupon>
    )
  }

  return <CouponsComponent quantity={couponAmount} />
}

export default Coupons
